import { Card, Container, ListItem, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
export type OverallStudentGradingViewType = {
    totalScore: string;
    rank: string;
    totalTime: string;
    notAttempted: string;
};

const OverallStudentGradingView = (props: OverallStudentGradingViewType) => {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                alignSelf: 'stretch',
                justifyContent: 'space-evenly',
                backgroundColor: 'white',
            }}>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    alignSelf: 'stretch',
                }}>
                <Box minWidth='56px'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                        <path
                            d='M22.909 11.9999C22.909 18.0248 18.0248 22.909 11.9999 22.909C5.97499 22.909 1.09082 18.0248 1.09082 11.9999C1.09082 5.97499 5.97499 1.09082 11.9999 1.09082C18.0248 1.09082 22.909 5.97499 22.909 11.9999Z'
                            fill='#EF5350'
                        />
                        <circle cx='11.9999' cy='11.9999' r='10.9091' fill='#4CAF50' />
                    </svg>
                </Box>
                <Typography fontSize={16}>{t('resultPage.score') + '：' + props.totalScore}</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    alignSelf: 'stretch',
                }}>
                <Box minWidth='56px'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                        <path d='M10 20H14V4H10V20ZM4 20H8V12H4V20ZM16 9V20H20V9H16Z' fill='#F05023' />
                    </svg>
                </Box>
                <Typography fontSize={16}>{t('resultPage.rank') + '：' + props.rank}</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    alignSelf: 'stretch',
                }}>
                <Box minWidth='56px'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                        <path
                            d='M18.41 5.79988L17.2 4.58988C16.42 3.80988 15.15 3.80988 14.37 4.58988L3 15.9599V19.9999H7.04L18.41 8.62988C19.2 7.84988 19.2 6.57988 18.41 5.79988ZM6.21 17.9999H5V16.7899L13.66 8.12988L14.87 9.33988L6.21 17.9999ZM11 19.9999L15 15.9999H21V19.9999H11Z'
                            fill='#533D18'
                            fill-opacity='0.56'
                        />
                    </svg>
                </Box>
                <Typography fontSize={16}>{t('resultPage.totalAnswerTime') + '：' + props.totalTime}</Typography>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '8px 16px',
                    alignSelf: 'stretch',
                }}>
                <Box minWidth='56px'>
                    <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'>
                        <path d='M1 21H23L12 2L1 21ZM13 18H11V16H13V18ZM13 14H11V10H13V14Z' fill='#FFCA28' />
                    </svg>
                </Box>
                <Typography fontSize={16}>{t('resultPage.totalNotAttemptedQuestion') + '：' + props.notAttempted}</Typography>
            </Box>
        </Box>
    );
};

export default OverallStudentGradingView;
